import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService } from 'app/services/data.service';

@Component({
  selector: 'app-confirm-dismiss-dialog',
  templateUrl: './confirm-dismiss-dialog.component.html',
  styleUrls: ['./confirm-dismiss-dialog.component.scss'],
  providers: [DialogService],
})
export class ConfirmDismissDialogComponent implements OnInit {
  data: any = {};
  showFooter: boolean = true;
  headerIcon: string = '';
  headerIconPrimary: boolean = false;
  isCloseButtonHidden: boolean = false;
  isShowInputField: boolean = false;
  confirmationText: string = '';
  isValid: boolean = false;
  headerIconType: string = ''

  constructor(private dialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private dataService: DataService) {}

  ngOnInit() {
    this.data = this.dialogConfig.data;
    // ALP-18097 Overlap Fix for sublet and payment modal from kanban component
    setTimeout(() => {
      if(this.data.isOpenFromKanban) {
        const supplierNotAssignedOverlayDialog = document.querySelectorAll<HTMLElement>('.p-component-overlay');
        supplierNotAssignedOverlayDialog[0].style.zIndex = (Number(supplierNotAssignedOverlayDialog[0].style.zIndex) + 1000).toString();
      }
    }, 100);
    this.headerIcon = this.data.headerIcon;
    this.headerIconPrimary = this.data.headerIconPrimary;
    this.headerIconType = this.data.headerIconType;
    this.isCloseButtonHidden = this.data.isCloseButtonHidden;
    this.isShowInputField = this.data.isShowInputField;
    if (this.data && this.data.hasOwnProperty('showFooter')) {
      this.showFooter = this.data.showFooter;
    }
  }


  handleChange(value: string) {
    if (this.data.type === 'Confirm') {
      this.confirmationText = value;
      this.isValid =
        `${this.data.type}` ===
        `${this.confirmationText}`;
    }
  }

  closeDialog(isSuccess: boolean, btn = '') {
    this.data.btn = btn;
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    this.dynamicDialogRef.close({ isSuccess, data: this.data });
  }
}
